import React, { useMemo, useState } from 'react'
import { Badge } from 'reactstrap'
import { IconArrowDown, IconClose } from '@Knowledge-OTP/znk-ui-components'

const FilterBadge = ({
  title,
  options = [],
  selectedIds = [],
  className = 'mx-1 filters w-auto',
  showArrow = true,
  showOptionComponents = false,
  isActive = false,
  icon,
  onClick,
  onClearFilters
}) => {
  const [isHovered, setIsHovered] = useState(false)

  const selectedNames = useMemo(() => (
    selectedIds
      .map((id) => options.find((option) => option.id === id)?.name)
      .filter(Boolean)
  ), [options, selectedIds])

  const selectedOptions = useMemo(() => (
    selectedIds
      .map((id) => options.find((option) => option.id === id))
      .filter(Boolean)
  ), [options, selectedIds])

  const allOptionsSelected = options.length > 0 && options.every((option) => selectedIds.includes(option.id))

  const hasSelectedOptions = isActive || selectedNames.length > 0
  const canClear = hasSelectedOptions && typeof onClearFilters === 'function'
  const label = allOptionsSelected
    ? 'All'
    : selectedNames.length > 2
      ? selectedNames[0]
      : selectedNames.join(', ')

  return (
    <Badge
      className={className}
      pill
      color={hasSelectedOptions ? 'option' : undefined}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        padding: "0.4rem 1.125rem",
        borderRadius: '999px',
        fontSize:"14px",
        fontWeight:"500",
        textAlign:"left",
        gap:"15px",
        display: 'inline-flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : undefined,
        ...(isHovered && { backgroundColor: 'rgb(228, 234, 241)' })
      }}
    >
      <label
        style={{
          cursor: onClick ? 'pointer' : undefined,
          display: 'inline-flex',
          alignItems: 'center',
          flex: 1,
          textAlign: 'left'
        }}
        className='m-0 p-0 text-left'
      >
        {icon}
        {showOptionComponents && !allOptionsSelected && selectedOptions.slice(0, 2).map((option) => (
          <span key={option.id} className='m-0 p-0 d-flex flex-row align-items-center'>
            {option.Component}
          </span>
        ))}
        <span>{`${title}${label ? ': ' + label : ''}`}</span>
        {!allOptionsSelected && selectedNames.length > 2 && (
          <Badge className='ml-2 number' pill color='primary'>
            +{selectedNames.length - 1}
          </Badge>
        )}
        {canClear && (
          <span
            className='d-inline-flex align-items-center justify-content-center p-0 m-0 ml-2'
            style={{
              visibility: isHovered ? 'visible' : 'hidden',
              fontSize: '13px',
              cursor: 'pointer',
              flexShrink: 0
            }}
            onClick={(event) => {
              event.stopPropagation()
              onClearFilters()
            }}
          >
            <IconClose size={13} color='#696CFF'/>
          </span>
        )}
        {showArrow && <IconArrowDown className='ml-2' size={10} />}
      </label>
  
    </Badge>
  )
}

export default FilterBadge
